/**
 * Environment Configuration
 * Centralized configuration for different environments
 */

import { API_BASE_URL } from "constants";

const config = {
  development: {
    API_BASE_URL,
    DATA_BASE_URL: "/data",
    CACHE_DURATION: 15 * 60 * 1000, // 15 minutes (increased for speed)
    DEBUG: true,
    LOG_LEVEL: "debug",
  },
  production: {
    API_BASE_URL,
    DATA_BASE_URL: "/data",
    CACHE_DURATION: 60 * 60 * 1000, // 1 hour (increased for speed)
    DEBUG: false,
    LOG_LEVEL: "error",
  },
  test: {
    API_BASE_URL,
    DATA_BASE_URL: "/test-data",
    CACHE_DURATION: 0, // No caching in tests
    DEBUG: true,
    LOG_LEVEL: "warn",
  },
};

const environment = process.env.NODE_ENV || "development";

export const ENV_CONFIG = config[environment];

export const isDevelopment = environment === "development";
export const isProduction = environment === "production";
export const isTest = environment === "test";

// Feature flags
export const FEATURES = {
  ENABLE_ANALYTICS: isProduction,
  ENABLE_DEBUG_TOOLS: isDevelopment,
  ENABLE_MOCK_DATA: isDevelopment || isTest,
  ENABLE_OFFLINE_MODE: true,
};

export default ENV_CONFIG;
